module.exports = __webpack_public_path__ + "fonts/montserrat-regular-webfont.51d9a8c9.woff";